module.exports = __webpack_public_path__ + "static/kovka8-425a1945ecf7f9e265f4dbf7ebcccd4a.png";